<template>
  <UiPopover>
    <UiBaseIcon slot="trigger" color="#DADADA" icon-name="moreHoriz" />

    <div slot="content">
      <div v-for="action in actions" :key="action.key">
        <UiPopoverItem @click="managerActionClicked(action)">
          <UiBaseIcon slot="icon" v-bind="action.icon" class="action-icon" />

          <span slot="label">{{ action.label }}</span>
        </UiPopoverItem>
      </div>
    </div>
  </UiPopover>
</template>

<script>
import UiPopover from '@/components/UiPopover.vue'
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

import { banManager, unbanManager } from './RowActionsMethods.js'

import UiPopoverItem from '@/components/UiPopoverItem.vue'

export default {
  components: { UiPopover, UiPopoverItem, UiBaseIcon },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    actions() {
      const isBanned = this.row && this.row.deleted_at

      return [
        {
          key: isBanned ? 'unbanManager' : 'banManager',
          label: isBanned ? 'Разблокировать доступ' : 'Блокировать доступ',
          icon: {
            'icon-name': 'block',
            width: '14px',
            height: '14px',
            color: '#9DA9B8',
          },
        },
      ]
    },
  },
  methods: {
    /**
     * Run method by action.
     *
     * @param {string} action Action methods name.
     * @returns {void} Run action method by `action` with bind context
     */
    managerActionClicked(action) {
      /** {object} `actionsHashes` Object contains all actions */
      const actionsHashes = { banManager, unbanManager }

      actionsHashes[action.key].call(this)
    },
  },
}
</script>
